import { App, Button, Checkbox, Form, Input, Modal, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useHttp } from '../../Hooks/Http.hook';
import { InputPhone } from '../InputPhone';
// import { Captcha } from "../Captcha";

export const CallUsRequest = ({ text = '', style = {} }) => {
    const [form] = Form.useForm();
    const [isAgree, setIsAgree] = useState(false);
    const [isOpenedModal, setIsOpenedModal] = useState(false);
    // const [isOpenedCaptcha, setIsOpenedCaptcha] = useState(false)
    const { notification } = App.useApp();
    const { request, loading } = useHttp(false);

    const onFinish = () => {
        const fields = form.getFieldsValue();

        request(`/api/call-us-request`, 'POST', {
            name: fields.name.trim(),
            phone: fields.phone.match(/\d+/g).splice(1, 5).join(''),
            comment: fields.comment,
            url: window.location.href,
        })
            .then((res) => {
                if (res.error) {
                    notification.error({ message: res.error.message });
                } else {
                    notification.success({
                        message:
                            'Ваша заявка направлена.\nСкоро мы Вам перезвоним',
                    });
                }
            })
            .catch(() =>
                notification.error({
                    message:
                        'Ошибка сервера. Попробуйте перезагрузить страницу.',
                })
            );
    };

    return (
        <>
            <Button
                size="large"
                type="primary"
                style={{ maxWidth: 300, margin: '0 auto', ...style }}
                onClick={() => setIsOpenedModal(true)}
            >
                {text || 'Заказать обратный звонок'}
            </Button>
            <Modal
                open={isOpenedModal}
                footer={null}
                onCancel={() => setIsOpenedModal(false)}
            >
                <div style={{ maxWidth: 600, margin: '0 auto' }}>
                    <Row style={{ fontSize: 24 }}>Заказать обратный звонок</Row>
                    <Form form={form} disabled={loading} onFinish={onFinish}>
                        <Row style={{ width: '100%', marginTop: 20 }}>
                            <Form.Item
                                style={{ width: '100%' }}
                                name="name"
                                validateDebounce={3000}
                                rules={[
                                    {
                                        required: true,
                                        message: '',
                                    },
                                    () => ({
                                        validator(_, value) {
                                            if (value?.trim().length > 0) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(
                                                new Error(
                                                    'Введите пожалуйста фамилию'
                                                )
                                            );
                                        },
                                    }),
                                ]}
                            >
                                <Input
                                    style={{ width: '100%', fontSize: 14 }}
                                    placeholder="Представьтесь пожалуйста"
                                />
                            </Form.Item>
                        </Row>

                        <Row style={{ width: '100%' }}>
                            <Form.Item
                                style={{ width: '100%' }}
                                name="phone"
                                validateDebounce={3000}
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (
                                                !value ||
                                                (value ?? '')
                                                    .match(/\d+/g)
                                                    .join('').length !== 11
                                            ) {
                                                return Promise.reject(
                                                    rule.message
                                                );
                                            }
                                            return Promise.resolve();
                                        },
                                        message: 'Введите телефон',
                                    },
                                ]}
                            >
                                <InputPhone
                                    disabled={loading}
                                    name="phone"
                                    className={`ant-input ${
                                        loading ? 'ant-input-disabled' : ''
                                    }`}
                                    placeholder="+7 (___) ___-__-__"
                                    alwaysShowMask
                                    mask="+7 (999) 999-99-99"
                                />
                            </Form.Item>
                        </Row>

                        <Row style={{ width: '100%' }}>
                            <Form.Item style={{ width: '100%' }} name="comment">
                                <TextArea
                                    style={{ fontSize: 14 }}
                                    autoSize={{
                                        minRows: 4,
                                        maxRows: 4,
                                    }}
                                    placeholder="Комментарий к заказу"
                                />
                            </Form.Item>
                        </Row>

                        <Row>
                            <Checkbox
                                checked={isAgree}
                                onChange={() => setIsAgree(!isAgree)}
                            >
                                Нажимая на кнопку, Вы даете согласие на
                                обработку персональных данных и соглашаетесь
                                с&nbsp;
                                <a
                                    href="../../Политика конфиденциальности.pdf"
                                    target="_blank"
                                >
                                    политикой конфиденциальности
                                </a>
                            </Checkbox>
                        </Row>

                        <Row justify="center">
                            <Button
                                style={{ width: 300, marginTop: 20 }}
                                size="large"
                                type="primary"
                                htmlType="submit"
                                disabled={!isAgree}
                            >
                                Отправить
                            </Button>
                        </Row>
                    </Form>
                </div>

                {/* <Captcha
                      open={isOpenedCaptcha}
                      setOpen={setIsOpenedCaptcha}
                      onFinish={onFinish}
                  /> */}
            </Modal>
        </>
    );
};
